const GENERIC_FALLBACK_MESSAGES = new Set([
  'something went wrong',
  'something went wrong!',
  'something went wrong!!!',
  'request failed',
  'error',
  'unknown error'
])

const STANDARD_KEYS = new Set([
  'error_code',
  'message',
  'detail',
  'details',
  'error_reason_code',
  'code',
  'status',
  'statusCode',
  'error',
  'errorData',
  'errorCode',
  'cause',
  'config'
])

const isMeaningful = str => {
  if (typeof str !== 'string') return false
  const trimmed = str.trim()
  if (!trimmed || trimmed.toLowerCase() === 'none') return false
  return !GENERIC_FALLBACK_MESSAGES.has(trimmed.toLowerCase())
}

const collectPayloads = error => {
  const payloads = []
  const push = payload => {
    if (payload && typeof payload === 'object') {
      payloads.push(payload)
    }
  }

  push(error?.response?.data)
  push(error?.data)
  push(error?.errorData)
  push(error)

  return payloads
}

const extractFieldErrors = payload => {
  if (!payload || typeof payload !== 'object') return []

  return Object.entries(payload)
    .filter(([key]) => !STANDARD_KEYS.has(key))
    .map(([, value]) => {
      if (Array.isArray(value) && value.length > 0) {
        const first = String(value[0]).trim()
        return isMeaningful(first) ? first : null
      }
      if (typeof value === 'string' && isMeaningful(value)) {
        return value.trim()
      }
      return null
    })
    .filter(Boolean)
}

const formatErrorCode = errorCode =>
  errorCode
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')

export const parseErrorMessage = error => {
  const payloads = collectPayloads(error)
  let parsed = ''

  for (const payload of payloads) {
    if (isMeaningful(payload?.message)) {
      parsed = payload.message.trim()
      break
    }
  }

  if (!parsed) {
    for (const payload of payloads) {
      if (isMeaningful(payload?.detail)) {
        parsed = payload.detail.trim()
        break
      }
      if (isMeaningful(payload?.details)) {
        parsed = payload.details.trim()
        break
      }
    }
  }

  if (!parsed) {
    for (const payload of payloads) {
      const fieldErrors = extractFieldErrors(payload)
      if (fieldErrors.length > 0) {
        parsed = fieldErrors[0]
        break
      }
    }
  }

  if (!parsed) {
    for (const payload of payloads) {
      if (payload?.error_code) {
        parsed = formatErrorCode(payload.error_code)
        break
      }
    }
  }

  if (!parsed) {
    const topLevelMessage = error?.message?.trim()
    parsed = isMeaningful(topLevelMessage) ? topLevelMessage : ''
  }

  return parsed
}
